<script setup lang="ts">
  import { MpFile } from '@borg/types';
  import { MpField } from '@borg/ui';
  import { isUndefined, toggleElementInArray } from '@borg/utils';

  const props = defineProps<{
    modelValue: string[];
  }>();

  const emit = defineEmits<{
    (event: 'update:modelValue', value: string[]): void;
  }>();

  const applicationForm = _applicationForm.inject();
  const { errorMessage, filesForUpload, onFilesForUploadSelected } = useValidateFilesBeforeUpload();

  function onToggleDocument(file: MpFile) {
    emit('update:modelValue', toggleElementInArray(props.modelValue, file.id));
  }

  function onDocumentUploaded(file: MpFile) {
    applicationForm.application?.documents.unshift(file);
    emit('update:modelValue', [...props.modelValue, file.id]);
  }

  function onDocumentDeleted(file: MpFile) {
    if (applicationForm.application) {
      applicationForm.application.documents = applicationForm.application.documents.filter(
        (f) => f.id !== file.id,
      );
    }
  }

  function onDocumentEdited(file: MpFile) {
    const documentIndex = applicationForm.application?.documents.findIndex((f) => f.id === file.id);
    if (applicationForm.application && !isUndefined(documentIndex) && documentIndex >= 0) {
      applicationForm.application.documents[documentIndex] = file;
    }
  }
</script>

<template>
  <DocumentsList
    source="document"
    :model-value="props.modelValue"
    :files="applicationForm.application?.documents"
    :files-for-upload="filesForUpload"
    selectable
    multi-selectable
    @toggle="onToggleDocument"
    @file-deleted="onDocumentDeleted"
    @file-uploaded="onDocumentUploaded"
    @file-edited="onDocumentEdited"
  />
  <MpField :error="errorMessage">
    <UploadSurface
      :has-error="!!errorMessage"
      :accept="DEFAULT_HTML_ACCEPT_PARAMETER"
      class="other-upload-surface"
      @change="onFilesForUploadSelected"
    />
  </MpField>
</template>

<style scoped lang="scss">
  .other-upload-surface {
    margin-top: var(--mp-space-50);
  }
</style>
